export enum GlobalDisplayNames {

  'BankNumber_0006_TransactionIdentifier_SEQno' = 'Tracer Daily Counter',
   
  'BankNumber_0006_TransactionIdentifier_SEQno_Collections' = 'Tracer Collection Daily Counter',

  'DebiCheck_RealTime Server Active' = 'RealTime Main Server Active',

  'DebiCheck_RealTime Server DR Active' = 'RealTime DR Server Active',

  'Debicheck_Collections FileNo' = 'Collections File No',

  'Debicheck_CreditorDebitor' = 'CreditorDebtorSystem (1 Creditor)',

  'Debicheck_Fortnightly Cycle Duration' = 'Fortnightly Cycle',

  'Debicheck_Fortnightly Cycle Duration_December' = 'Fortnightly Cycle (December)',

  'Debicheck_Monthly Cycle Duration' = 'Monthly Cycle',

  'Debicheck_Monthly Cycle Duration_December' = 'Monthly Cycle (December)',

  'Debicheck_Other Cycle Duration' = ' Other frequency Cycle',

  'Debicheck_Other Cycle Duration_December' = 'Other frequency Cycle (December)',

  'CreateDDINPXML_MaximumNoOfContracts' = 'Maximum number of Mandates for OffUs collection request (DDINP)',

  'CreateDDINPXML Onus_MaximumNoOfContracts' = 'Maximum number of Mandates for OnUs collection request (DDINP)',

  'DateAdjustmentRuleIndicatorDefault' = 'Date Adjustment Rule',
  
  'TT2TestLive' = 'Debicheck Environment (Test/Live)',

  'TrackingIndicatorDefault' = 'Tracking Indicator',

  'Transfer_Default From Branch' = 'Default From branch for Payouts',

  'Transfer_Default To Branch' = 'Default To branch for Payouts',

  'MaximumNumberOfInstallments' = 'Maximum Number of Installments',

  'MinimumNumberOfInstallments' = 'Minimum Number of Installments',

  'Debicheck_DefaultNoOfContinousInstallments' = 'Default Number of Continuous Installments',

  'CreateRDINPXML_MaximumNoOfContracts' = 'Maximum number of RM Mandates for OffUs collection request',

  'Debicheck_AutoCancelLimit' = 'Auto-cancel limit after failed attempts',

  ///Added PayerFee SMS Globals 2026/07/10 NS
  'Debicheck_PayerfeeSMS' = 'PayerFee SMS Link Document Enabled',

  /// Overwrite CreditorBank to AccessBank #15262  2026/09/08 NS
  'Debicheck_OverwriteCreditorBank' = 'Overwrite CreditorBank to AccessBank',

  'TDS_MaxView' = 'PayerFee SMS Link Document maximum views',

  'TDS_Expiry time' = 'PayerFee SMS Link Document time to expire (in hours)',

  /// PIN = Payment Instruction globals (^PINReq)  2026/08/04 NS
  /// active keys only; dead globals commented out  2026/08/04 NS
  // 'AuthorizationIndicator' = 'Authorization Indicator',
  'Capitec_CreditorAccountNumber' = 'Capitec Creditor Account Number',
  'Capitec_CreditorBranchCode' = 'Capitec Creditor Branch Code',
  'CreditorAccountNumber' = 'Creditor Account Number',
  'CreditorBANRno' = 'Creditor BANR Number',
  'CreditorBranchCode' = 'Creditor Branch Code',
  // 'CreditorShortName' = 'Creditor Short Name',
  // 'Debtor_MandateReferenceNumber' = 'Debtor Mandate Reference Number',
  'GenerateMACMethod' = 'Generate MAC Method',
  // 'MessageID' = 'Message ID',
  // 'MmbId' = 'Member ID (MmbId)',
  // 'StaticCreditorName' = 'Static Creditor Name',
  'TT1Count' = 'TT1 Count',
  'TT1Count Amend' = 'TT1 Count Amend',
  'TT1Count Cancel' = 'TT1 Count Cancel',
  // 'TT1PACS002Count' = 'TT1 PACS002 Count',
  // 'TT1PAIN012Count' = 'TT1 PAIN012 Count',
  // 'TracernumberCounter' = 'Tracer Number Counter',
  // 'TracernumberPre' = 'Tracer Number Prefix',
  'TrackingIndicator' = 'PIN Tracking Indicator',
  'WorkTelephoneNo' = 'Work Telephone Number'

}

/**
 * Utility function to get a user-friendly display name for a global variable
 * @param globalName The technical name of the global variable
 * @returns The display name if found, otherwise returns the original name
 */
export function getGlobalDisplayName(globalName: string): string {
  return GlobalDisplayNames[globalName as keyof typeof GlobalDisplayNames] || globalName;
}
